var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListItemdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    zoomAndPan: "magnify",
    viewBox: "0 0 48 48",
    height: 64,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "02a820654d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.417969 0 L 44.558594 0 L 44.558594 29 L 3.417969 29 Z M 3.417969 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "70626c04fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.417969 8 L 44.558594 8 L 44.558594 38 L 3.417969 38 Z M 3.417969 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a735b3535"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.417969 18 L 44.558594 18 L 44.558594 47.019531 L 3.417969 47.019531 Z M 3.417969 18 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02a820654d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd3842",
    d: "M 44.511719 0.03125 L 3.480469 0 L 23.957031 28.476562 Z M 44.511719 0.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#70626c04fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd3842",
    d: "M 43.910156 9.605469 L 23.957031 37.21875 L 4.101562 9.589844 L 43.910156 9.605469 M 44.558594 9.605469 C 44.558594 9.507812 44.542969 9.410156 44.496094 9.3125 C 44.382812 9.101562 44.152344 8.953125 43.910156 8.953125 L 4.101562 8.9375 C 3.855469 8.9375 3.628906 9.070312 3.515625 9.296875 C 3.464844 9.394531 3.449219 9.492188 3.449219 9.589844 C 3.449219 9.71875 3.5 9.847656 3.578125 9.960938 L 23.4375 37.59375 C 23.566406 37.753906 23.761719 37.867188 23.957031 37.867188 C 24.167969 37.867188 24.363281 37.769531 24.476562 37.59375 L 44.429688 9.996094 C 44.511719 9.882812 44.558594 9.75 44.558594 9.605469 Z M 44.558594 9.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a735b3535)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd3842",
    d: "M 43.875 18.773438 L 23.921875 46.371094 L 4.066406 18.738281 L 43.875 18.773438 M 44.527344 18.773438 C 44.527344 18.675781 44.511719 18.578125 44.460938 18.480469 C 44.347656 18.269531 44.121094 18.121094 43.875 18.121094 L 4.066406 18.089844 C 3.824219 18.089844 3.597656 18.21875 3.480469 18.445312 C 3.433594 18.542969 3.417969 18.640625 3.417969 18.738281 C 3.417969 18.871094 3.464844 19 3.546875 19.113281 L 23.402344 46.742188 C 23.53125 46.90625 23.726562 47.019531 23.921875 47.019531 C 24.136719 47.019531 24.328125 46.921875 24.445312 46.742188 L 44.398438 19.160156 C 44.480469 19.046875 44.527344 18.902344 44.527344 18.773438 Z M 44.527344 18.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListItemdown);
export default __webpack_public_path__ + "static/media/listItemdown.73a2f22d00d467b80ae95af3ef72198d.svg";
export { ForwardRef as ReactComponent };